import React from "react";
import Project from "../../../api/project";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.css";
import { Fade } from "react-awesome-reveal";

const ProjectSection = ({ data }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="project pb-140 o-hidden">
      <div className="container">
        <div className="pro-top ul_li_between mb-65 " dir="rtl">
          <div className="sec-title">
            <Fade
              direction="up"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <h2
                  className="title mb-15 wow fadeInLeft text-end"
                  data-wow-duration="600ms"
                >
                  نمونه کارها
                </h2>
              </div>
            </Fade>
            <Fade
              direction="up"
              triggerOnce={"false"}
              duration={1000}
              delay={9}
            >
              <div>
                <span
                  className="content wow fadeInLeft"
                  data-wow-duration="600ms"
                >
                </span>
              </div>
            </Fade>
          </div>
       
        </div>
      </div>
      <div className="project-wrapper pos-rel">
        <div className="project-slider">
          <Swiper
            modules={[Pagination, Autoplay]}
            loop={true}
            spaceBetween={60}
            speed={400}
            slidesPerView={3}
            centeredSlides={true}
            autoplay={{
                delay: 6000,
                disableOnInteraction: false,
            }}
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
            }}
            breakpoints={{
              1600: { slidesPerView: 3 },
              1024: { slidesPerView: 1 },
              768: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              0: { slidesPerView: 1 },
            }}
          >
            {data.map((project, prj) => (
              <SwiperSlide key={prj}>
                <div className="project-item">
                  <div
                    className="xb-item--inner ul_li align-items-start"
                    key={prj}
                  >
                    <div className="xb-item--right_img">
                      <Link
                        onClick={ClickHandler}
                        to={`/portfolio_details/${project.slug}`}
                      >
                        <img src={project.file_path} alt="" />
                      </Link>
                    </div>
                    <div className="xb-item--left_item" dir="rtl">
                      <div className="xb-item--icon">
                        <img
                          src={
                            project.files_main_path + project.files[0].file_name
                          }
                          alt=""
                        />
                      </div>
                     <a href={project.summary}> <h3 className="xb-item--title">{project.title}</h3></a>
                      <ul className="category list-unstyled ul_li">
                        {JSON.parse(project.fields).map(
                          (item) =>
                            item.value && <li key={item.id} className="mx-2 px-2 py-1 rounded-4 border">{item.value}</li>
                        )}
                      </ul>
                      {/* <div className="work-btn">
                                                <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`} className="thm-btn thm-btn--fill_icon thm-btn--strock">
                                                    <div className="xb-item--hidden"><span className="xb-item--hidden-text">View case study</span></div>
                                                    <div className="xb-item--holder">
                                                        <span className="xb-item--text">View case study</span>
                                                        <div className="xb-item--icon"><i className="far fa-long-arrow-right"></i></div>
                                                        <span className="xb-item--text">View case study</span>
                                                    </div>
                                                </Link>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
            <div className="swiper-pagination"></div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
